import Feature12 from './Feature12'
export default Feature12
